<template>
    <div class="outer-box" >
      <h4>Remove Restriction on Inbound Call</h4>
  
      <div class="inner-box" style="text-align: left; width: 500px;">
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Location ID"
          v-model="locationId"
        />
        <button class="btn btn-primary mt-4" @click="unBlockInboundCall">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Remove Restriction </span>
        </button>
        <pre v-if="response" class="response-box">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
import { SaasService } from '@/services';
  
  export default {
    data() {
      return {
        locationId: '',
        processing: false,
        response: null
      };
    },
    methods: {
      async unBlockInboundCall() {
        try{
          this.processing = true;
          await SaasService.editTwilioAccount(this.locationId, { key:'incomingCallBlocked', value: false })
          this.response = "Updated successfully"
        }
        catch (err) {
            this.response = err.response.data
        }
        finally {
            this.processing = false;
        }
      }
    }
  }
  </script>

<style scoped>
.response-box {
    background-color: #f2f7fa;
    padding: 16px;
    margin-top: 16px
}

.content-box {
  text-align: left;
  width: 500px;
}
</style>
  